import { render, staticRenderFns } from "./PlayerMonitorDeleteModal.vue?vue&type=template&id=67248dee&scoped=true&"
import script from "./PlayerMonitorDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./PlayerMonitorDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67248dee",
  null
  
)

export default component.exports